import { PageContent } from 'components/layout/PageContent'
import React, { Dispatch } from 'react'

import { AtendimentoFooter } from '../AtendimentoFooter'

interface AtendimentoAntecedentesViewProps {
  atendimentoId: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

export function AtendimentoAntecedentesView(props: AtendimentoAntecedentesViewProps) {
  return (
    <>
      <PageContent fluid type='filled'>
        Antecedentes
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        isAtendimentoOdonto={props.isAtendimentoOdonto}
        clearCache={props.clearCache}
      />
    </>
  )
}
